import { Faker, ko } from "@faker-js/faker"
import { Options } from "./types"

/**
 * 기본 옵션 설정
 */
export const defaultOptions: Options = {
  path: "",
  arrayMinLength: 1,
  arrayMaxLength: 3,
  includeCodes: undefined,
  baseDir: "./",
  specialPath: undefined,
  handlerUrl: "*",
  fakerLocale: "ko",
  generateTarget: "api,schema",
  clear: false,
  // TypeScriptCodeOptions
  isStatic: false,
  isOptional: false,
}

/**
 * 배열 길이 관련 상수
 */
export const ARRAY_MIN_LENGTH = 1
export const ARRAY_MAX_LENGTH = 3

/**
 * 문자열 길이 관련 상수
 */
export const MIN_STRING_LENGTH = 3
export const MAX_STRING_LENGTH = 20

/**
 * 정수 범위 관련 상수
 */
export const MIN_INTEGER = 1
export const MAX_INTEGER = 100000

/**
 * 소수 범위 관련 상수
 */
export const MIN_NUMBER = 0
export const MAX_NUMBER = 100

/**
 * 단어 길이 관련 상수
 */
export const MIN_WORD_LENGTH = 0
export const MAX_WORD_LENGTH = 3

/**
 * Faker 시드값 (일관된 결과를 위함)
 */
const FAKER_SEED = 1

/**
 * 전역 Faker 인스턴스
 * 한국어 로케일을 기본으로 설정하고 시드를 고정하여 일관된 결과 제공
 */
export const faker = new Faker({
  locale: [ko],
})
faker.seed(FAKER_SEED)

/**
 * 생성된 파일의 상단에 추가되는 주석
 */
export const GEN_COMMENT =
  "/* Do not edit this file. */\n/* This file generated by openapi-ts-mock-generator. */\n\n"
